module.exports = require("copy-to-clipboard");